import jsPDF from 'jspdf';

interface PDFData {
  iqScore: number;
  percentile: number;
  category: {
    label: string;
    description: string;
  };
  level: string;
  accuracy: number;
  score: number;
  totalQuestions: number;
}

export const generatePDF = (data: PDFData) => {
  const doc = new jsPDF({
    orientation: 'landscape',
    unit: 'mm',
    format: 'a4',
  });

  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();

  // Background gradient effect (simulated with rectangles)
  doc.setFillColor(139, 92, 246);
  doc.rect(0, 0, pageWidth, 30, 'F');
  doc.setFillColor(59, 130, 246);
  doc.rect(0, 30, pageWidth, 30, 'F');

  // Border
  doc.setDrawColor(139, 92, 246);
  doc.setLineWidth(2);
  doc.rect(10, 10, pageWidth - 20, pageHeight - 20);

  // Title
  doc.setTextColor(255, 255, 255);
  doc.setFontSize(32);
  doc.setFont('helvetica', 'bold');
  doc.text('IQ TEST CERTIFICATE', pageWidth / 2, 25, { align: 'center' });

  doc.setFontSize(14);
  doc.setFont('helvetica', 'normal');
  doc.text('Official Results Report', pageWidth / 2, 35, { align: 'center' });

  // Main content area
  doc.setTextColor(50, 50, 50);
  doc.setFontSize(18);
  doc.setFont('helvetica', 'bold');
  doc.text('This certifies that', pageWidth / 2, 60, { align: 'center' });

  // Test taker name placeholder
  doc.setFontSize(16);
  doc.setFont('helvetica', 'normal');
  doc.text('Test Participant', pageWidth / 2, 70, { align: 'center' });

  doc.setFontSize(14);
  doc.text('has successfully completed the IQ Test', pageWidth / 2, 80, { align: 'center' });

  // Results box
  const boxY = 95;
  doc.setFillColor(249, 250, 251);
  doc.roundedRect(40, boxY, pageWidth - 80, 65, 5, 5, 'F');

  // IQ Score - Large and prominent
  doc.setFontSize(48);
  doc.setFont('helvetica', 'bold');
  doc.setTextColor(139, 92, 246);
  doc.text(`${data.iqScore}`, pageWidth / 2, boxY + 25, { align: 'center' });

  doc.setFontSize(14);
  doc.setTextColor(100, 100, 100);
  doc.text('IQ SCORE', pageWidth / 2, boxY + 33, { align: 'center' });

  // Category
  doc.setFontSize(16);
  doc.setFont('helvetica', 'bold');
  doc.setTextColor(59, 130, 246);
  doc.text(data.category.label, pageWidth / 2, boxY + 45, { align: 'center' });

  // Statistics
  const statsY = boxY + 55;
  doc.setFontSize(12);
  doc.setFont('helvetica', 'normal');
  doc.setTextColor(80, 80, 80);

  const leftX = 60;
  const rightX = pageWidth - 60;

  doc.text(`Percentile: ${data.percentile}%`, leftX, statsY);
  doc.text(`Level: ${data.level.charAt(0).toUpperCase() + data.level.slice(1)}`, rightX, statsY, { align: 'right' });
  
  doc.text(`Accuracy: ${data.accuracy}%`, leftX, statsY + 8);
  doc.text(`Score: ${data.score}/${data.totalQuestions}`, rightX, statsY + 8, { align: 'right' });

  // Footer
  doc.setFontSize(10);
  doc.setTextColor(120, 120, 120);
  doc.text('Date: ' + new Date().toLocaleDateString(), pageWidth / 2, pageHeight - 20, { align: 'center' });
  
  doc.setFontSize(8);
  doc.text('IQ Test Pro - For entertainment and educational purposes only', pageWidth / 2, pageHeight - 15, { align: 'center' });
  doc.text('This test is not a substitute for professional psychological assessment', pageWidth / 2, pageHeight - 11, { align: 'center' });

  // Decorative elements
  doc.setDrawColor(139, 92, 246);
  doc.setLineWidth(0.5);
  doc.line(pageWidth / 2 - 30, 50, pageWidth / 2 + 30, 50);
  doc.line(pageWidth / 2 - 30, pageHeight - 25, pageWidth / 2 + 30, pageHeight - 25);

  // Save the PDF
  doc.save(`IQ-Test-Certificate-${data.iqScore}.pdf`);
};
